import clsx from "clsx";
import React from "react";
import { useTheme } from "../context/ThemeContext";

const Input = ({
    props,
    className,
    afterAddon
}: {
    props: React.InputHTMLAttributes<HTMLInputElement>
    className?: string
    afterAddon?: React.ReactNode
}) => {
    const { isDark } = useTheme();
    return <div className={clsx(
        "w-full flex items-center gap-[8px] p-[12px] rounded-[8px] bg-[#F2F2F2] dark:bg-[#262626] text-[14px] text-black dark:text-white",
        "border border-transparent transition-all duration-200 focus-within:border-black dark:focus-within:border-white focus:outline-none",
        className,
    )}>
        <input
            {...props}
            className={clsx(
                "w-full p-0 rounded-0 border-0 outline-none bg-transparent",
                isDark ? "placeholder:text-white/50" : "placeholder:text-black/50"
            )}
        />
        {afterAddon && afterAddon}
    </div>;
};

export default Input;
